import React from 'react';

import { GreenButton } from '@share/components';
import { PlusSvg, MinusSvg } from '@share/assets';

import './style.scss';

interface IProps {
  add: () => void;
  minus: () => void;
  count: number;
  disabled?: boolean;
  min: number;
  max: number;
}

export const Counts: React.FC<IProps> = ({
  count,
  add,
  minus,
  min,
  max,
  disabled = false
}) => {
  return (
    <div className="activity-guest-count">
      <div className="activity-guest-count__button">
        <GreenButton
          onClick={minus}
          disabled={count <= min || disabled}
        >
          <MinusSvg />
        </GreenButton>
      </div>

      <div className="activity-guest-count__count">{count}</div>

      <div className="activity-guest-count__button">
        <GreenButton
          onClick={add}
          disabled={count >= max || disabled}
        >
          <PlusSvg />
        </GreenButton>
      </div>
    </div>
  );
};
